module.exports = "data:image/gif;base64,R0lGODlhGQAKAIAAAMyZzAAAACH5BAAAAAAALAAAAAAZAAoAAAINhI+py+0Po5y02ovzLQA7"